import React,{useEffect,useState,useRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Avatar from '@material-ui/core/Avatar';
import InputBase from '@material-ui/core/InputBase'
import SendIcon from '@material-ui/icons/Send';
import Divider from '@material-ui/core/Divider';
import PersonIcon from '@material-ui/icons/Person';

import Navbar from './Navbar'

import {useHistory } from "react-router-dom";

import CircularProgress  from '@material-ui/core/CircularProgress'
import Backdrop from '@material-ui/core/Backdrop';

import  io from "socket.io-client";

import Picker from 'emoji-picker-react';

const socket                = io('https://mernsocketmessenger.herokuapp.com/');



const useStyles = makeStyles(theme => ({
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 12,
    marginTop: theme.spacing(10),
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    top: 'auto',
    bottom: 0,
  },
  grow: {
    flexGrow: 1,
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
  input: {
    marginLeft: theme.spacing(2),
    flex: 1,
    width:'90%',
    border:'1px solid #3f51b5',
    padding :5
  },
  iconButton: {
    padding: 20,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  chat: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  chatmsg:{
    '&:nth-child(odd)': {
        textAlign:'right',
        backgroundColor:'#ac99993d'
    },
  },backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#3f51b5',
    background:'#fff'
  },
  typing:{
    color:'green'
  }
}));

export default function Chatroom() {
  const classes = useStyles();
  const [loading,setLoading]  = useState({loading:false,open:true});
  //const [open,setOpen]        = useState(true);
  const [messages,setMessage] = useState([]);
  const [typing,setTyping]    = useState('');
  const history = useHistory();
  const messagesEndRef = useRef(null)
  const   Auth = async ()=>{
    console.log('Auth')
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json','token' :localStorage.getItem('token')}
  };
  const requestOptions1 = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json','token' :localStorage.getItem('token')},
    body: JSON.stringify({"message":'message'})
};
  await fetch('https://mernsocketmessenger.herokuapp.com/user/auth', requestOptions)
      .then(response => {return response.json();})
      .then(data => {
        console.log(data);
        if(data.message!='Success'){
          localStorage.clear();
          history.push("/login");
        }
        
      }).catch(error=>{
        console.log(error);
        localStorage.clear();
        history.push("/login");
      });


      await fetch('https://mernsocketmessenger.herokuapp.com/user/msg', requestOptions)
      .then(response => {return response.json();})
      .then(data => {
        console.log(data);
        setMessage(data.msg);
        //setLoading(true);
        //setOpen(false)
        setLoading({loading:true,open:false})
        scrollToBottom()
        
      }).catch(error=>{
        console.log(error);
        //history.push("/login");
      });
  }
  useEffect(() => {
      // Update the document title using the browser API
       Auth();
      
      
  },[]);

  useEffect(()=>{ 
    socket.on('message',(msg)=>{
      console.log('----------Jomon-----------')
      let newMessage  = {_id: "5ead0778b1755031f867e951", userId: {_id:'',username:msg.username}, message: msg.msg};
      //messages.push(newMessage)
      if(messages.length>0){
        setMessage([...messages,newMessage]);
        document.getElementById('message').value='';
        scrollToBottom()
      console.log('state',messages);
      }
      
      //console.log(open)
    })
    //console.log(messages);
    //console.log(open)
    socket.on('someoneTyping',(user)=>{
      //console.log(user);
      if(user.username!==undefined){ setTyping(user.username +' is typing.....')}
      else{setTyping() }
    });
    
    
  },[messages])
  

  const sendMessage = (e) =>{
    
    let msg = document.getElementById('message').value.trim();
    if(msg=='') {alert("Please type a valid msg");return false;}
    setTyping('')
    socket.emit('newMessage',{msg:msg,username:localStorage.getItem('username')});
    scrollToBottom()
    const msgRequestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','token' :localStorage.getItem('token')},
      body: JSON.stringify({"message":msg})
  };
  fetch('https://mernsocketmessenger.herokuapp.com/user/msg', msgRequestOptions)
  .then(response => {return response.json();})
  .then(data => {
    console.log(data);
  }).catch(error=>{
    console.log(error);
  });
    
  } 

  const onChange = (e)=>{
    console.log(e.target.value)
    if(e.target.value.trim()==''){
      setTyping('');return false
    }
    socket.emit('typing',{username:localStorage.getItem('username')})
    const WAIT_INTERVAL = 1000;
    setTimeout(()=>{
      socket.emit('typing',{});
    }, WAIT_INTERVAL);
  }

  const scrollToBottom = () => {
    console.log(messagesEndRef);
    //messagesEndRef.current.scrollIntoView({ behavior: 'auto',block: "end" });
    messagesEndRef.current.scrollTop =  messagesEndRef.current.scrollHeight;
    console.log('Height',messagesEndRef.current.scrollHeight)
  }
  
 
  const renderData = () =>{
  if(loading.loading){
    console.log('SETLOADING')
  return (
    <Paper square className={classes.paper}>
        <Backdrop className={classes.backdrop} open={loading.open} >
            <CircularProgress color="inherit" />
        </Backdrop>    
        <Typography className={classes.text} variant="h5" gutterBottom>
          Inbox
        </Typography>
        
        <List className={classes.list} style={{height: '66vh', overflow: 'auto'}} ref={messagesEndRef} >
          {messages.map((data) => (
            <React.Fragment key={data._id}>
              {data._id === 1 && <ListSubheader className={classes.subheader}>Today</ListSubheader>}
              {data._id === 3 && <ListSubheader className={classes.subheader}>Yesterday</ListSubheader>}
              <ListItem button className={classes.chatmsg} >
                <ListItemAvatar>
                  <Avatar alt="Profile Picture" >
                    <PersonIcon/>
                  </Avatar>  
                  Sent by : {data.userId.username}
                </ListItemAvatar>
                <ListItemText primary={data.message} />
              </ListItem>
            </React.Fragment>
          ))}
        </List>
        <Paper  className={classes.chat}>
        <InputBase
        className={classes.input}
        placeholder="Send Message"
        inputProps={{ 'aria-label': 'Send Message' }}
        id="message" 
        onChange={onChange}
      />
      <Divider className={classes.divider} orientation="vertical" /> 
      <IconButton color="primary" className={classes.iconButton}  onClick={sendMessage} aria-label="directions">
     <SendIcon />
      </IconButton>
      
          </Paper>
      <Typography className={classes.typing} style={{display: 'inline-block',padding:'1px'}}>{typing}</Typography>
      </Paper>
  )
  }
  else{
    return(
      <Backdrop className={classes.backdrop} open={loading.open} >
            <CircularProgress   />
          </Backdrop>  
    )
  }
}
  return (
    <React.Fragment>
      <Navbar/>
      <CssBaseline />
      
      {renderData()}      
      
    </React.Fragment>
  );
}
